import { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo);
    }

    render() {
        if (this.state.error && this.props.isPage) {
            // If it's a page, render 500 error
            return (
                <div className="bk-scene-error">
                    <title>Error - Blòkur</title>
                    <div className="bk-code">500</div>
                    <h1>Internal Server Error</h1>
                    <h3>
                        Looks like we are having some issues displaying the page. If the problem persists, please
                        contact support.
                    </h3>
                    <a href={'/'}>Back to main page</a>
                </div>
            );
            // For everything else, just render blank
        } else if (this.state.error) {
            return null;
        }
        // Normally, just render children
        return this.props.children;
    }
}

export default ErrorBoundary;
